/**
 * Which user actions to detect and extend "is idle" states.
 *
 * @type {string[]}
 */
export const idleDetectionEvents = ['keydown', 'mousedown', 'touchstart', 'touchmove', 'dragleave']
